"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');




var _array = require('shared/services/array');

const selectAllDrafts = (state) => state.dataV2.session.conversationDrafts
 const selectDraftByConversationKey = (
  state,
  conversationKey,
) => {
  const draft = _optionalChain([selectAllDrafts, 'call', _ => _(state), 'optionalAccess', _2 => _2[conversationKey]])
  return typeof draft === 'string' ? draft : _optionalChain([draft, 'optionalAccess', _3 => _3.message]) || ''
}; exports.selectDraftByConversationKey = selectDraftByConversationKey

// Stable empty value so connected components and useSelector keep reference
// equality when a conversation has no draft mentions.
const EMPTY_DRAFT_MENTIONS = []

 const selectDraftMentionsByConversationKey = (
  state,
  conversationKey,
) => {
  const draft = _optionalChain([selectAllDrafts, 'call', _4 => _4(state), 'optionalAccess', _5 => _5[conversationKey]])
  return typeof draft === 'string' ? EMPTY_DRAFT_MENTIONS : _optionalChain([draft, 'optionalAccess', _6 => _6.mentions]) || EMPTY_DRAFT_MENTIONS
}; exports.selectDraftMentionsByConversationKey = selectDraftMentionsByConversationKey

/* Whether the conversation's draft came from a template (lane D), so its
 * {{…}} still block Send after the draft is restored. */
 const selectDraftFromTemplateByConversationKey = (
  state,
  conversationKey,
) => {
  const draft = _optionalChain([selectAllDrafts, 'call', _7 => _7(state), 'optionalAccess', _8 => _8[conversationKey]])
  return typeof draft === 'object' && _optionalChain([draft, 'optionalAccess', _9 => _9.fromTemplate]) === true
}; exports.selectDraftFromTemplateByConversationKey = selectDraftFromTemplateByConversationKey

 const selectHasAnyDrafts = _toolkit.createSelector.call(void 0, 
  selectAllDrafts,
  drafts => Object
    .values(drafts || {})
    .filter(_array.truthy)
    .length > 0,
); exports.selectHasAnyDrafts = selectHasAnyDrafts
